import { getTokenClientes } from "../Store/storages/AuthenticationStorage";
import { apiClientes } from "../config/api";
import { QuestaoPesquisaSatisfacao, RespostasPesquisaSatisfacao } from "../interfaces/entities/QuestaoPesquisaSatisfacao";

export const getQuestoes = async (idQuestOperador: string): Promise<QuestaoPesquisaSatisfacao[] | null> => {
    try {
        const response = await apiClientes.get('/PesquisaSatisfacao/GetQuestoes',{
            params: {idQuestOperador},
            headers: { Authorization: `Bearer ${ await getTokenClientes()}` } 
        });
      return response.data; // Retornar o valor da resposta, não a resposta completa
        
    } catch (error) {
        console.log({ error });
        return null;
    }
};

export const respQuestao = async (answers: RespostasPesquisaSatisfacao): Promise<any | null> => {
    try {
        const response = await apiClientes.post('/PesquisaSatisfacao/RespQuestao', answers, { headers: { Authorization: `Bearer ${await getTokenClientes()}` } });
        return response.data; // Retornar o valor da resposta, não a resposta completa

    } catch (error) {
        console.log({ error });
        return null;
    }
};